
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/components/Banner/Banner.scss.css.virtualfile';
        module.exports = {"container":"_container_1dxhv_1"};